export const FETCH_OPTS = { headers: { 'X-Requested-With': 'XMLHttpRequest' } };
